import { z } from 'zod';

import { requiredSelection } from '../../../../utils/validation';

/**
 * Validation for the product access toggle: a product must be selected
 * before the toggle action fires.
 */
export const productsSchema = z.object({
    product_id: requiredSelection('Product'),
});
